// extracted by mini-css-extract-plugin
export var container = "my-subscriptions-module--container--Wn2z2";
export var deleteButton = "my-subscriptions-module--delete-button--Au8SO";
export var link = "my-subscriptions-module--link--kOEjs";
export var list = "my-subscriptions-module--list--5fcTP";
export var noSubscriptionHeader = "my-subscriptions-module--no-subscription-header--iz++D";
export var noSubscriptionText = "my-subscriptions-module--no-subscription-text--4sUYf";
export var title = "my-subscriptions-module--title---7XTi";